export default {
  modal: {
    showModal: false,
    header: null,
    body: null,
    footer: null,
    buttonsOrCallback: null
  }
};
